import React from 'react';
import PropTypes from 'prop-types';
import {Avatar} from "material-ui";
import Dropzone from 'react-dropzone';
import ReportSubjectInfo from './ReportSubjectInfo/ReportSubjectInfo';
import styles from './ReportSubjectFull.css';
import style from '../../../styles/styles';

class ReportSubjectFull extends React.Component {

    static propTypes = {
        app: PropTypes.object.isRequired,
        subject: PropTypes.object.isRequired,
        postPicture: PropTypes.func.isRequired
    };

    static supportedDropFiles = 'image/jpeg, image/png';

    handlePictureDrop = (accepted, rejected) => {
        this.setState({uploadingFiles: []});

        accepted.forEach((picture) => {
            console.log('Uploading file ' + picture.name);
            this.props.postPicture(this.props.app.id, this.props.subject.id, picture, (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                const uploadingState = this.state.uploadingFiles.filter((mediaPercent) => mediaPercent.media !== picture);
                console.log(picture.name + ' -> ' + percentCompleted + '% (' + progressEvent.loaded + ' / ' + progressEvent.total + ')');
                this.setState({
                    uploadingFiles: [
                        ...uploadingState,
                        {
                            picture: picture,
                            percent: percentCompleted
                        }
                    ]
                });
            });
        });
    };

    render() {
        const {subject} = this.props;

        return (
            <div>
                <Dropzone
                    ref={(node) => {
                        this.dropzoneRef = node
                    }}
                    accept={ReportSubjectFull.supportedDropFiles}
                    onDrop={this.handlePictureDrop}
                    multiple={false}
                    style={{}}
                >
                    <Avatar
                        icon={subject.picture && <img src={subject.picture} alt="" style={style.image.contain}/>}
                        size={75}
                        backgroundColor={subject.color}
                        style={{ ...styles.avatar, overflow: 'hidden' }}
                    />
                </Dropzone>
                <div className="row">
                    <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                        <ReportSubjectInfo subject={subject}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default ReportSubjectFull;



// WEBPACK FOOTER //
// src/components/report/ReportSubjectFull/ReportSubjectFull.js